import VueRouter from 'vue-router';

//router.js里的 new Vue Router返回必须是： routes
const routes = [{
		path: '/',
		name: 'login',
		title: '网站后台管理系统',
		component: () => import('../pages/Login')
	},
	{
		path: '/index',
		name: 'index',
		title: '网站后台管理系统',
		component: () => import('../components/Index'),
		children: [{
				path: '/home',
				name: 'home',
				meta: {
					title: '首页'
				},
				component: () => import('../pages/Home'),
			},
			// {
			//     path: '/admin',
			//     name: 'admin',
			//     meta: {
			//         title: '管理员管理'
			//     },
			//     component: () => import('../pages/admin/AdminManage'),
			// },
			// {
			//     path: '/user',
			//     name: 'user',
			//     meta: {
			//         title: '用户管理'
			//     },
			//     component: () => import('../pages/user/UserManage'),
			// }
		]
	}
]

const router = new VueRouter({
	mode: 'history',
	routes
});

const newRouter = new VueRouter({
	mode: 'history',
});

export function resetRouter() {
	router.matcher = newRouter.matcher;
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

export default router;
